/* global axios */
import ApiClient from '../ApiClient';

// Số liệu thông báo đẩy: gửi / máy nhận / bấm, theo nhân viên và theo máy.
// Nguồn là sổ `bonboz_push_deliveries`, xem `Bonboz::PushReport`.
class PushReportAPI extends ApiClient {
  constructor() {
    super('bonboz/push_report', { accountScoped: true });
  }

  // `since` / `until` là giây Unix, đúng như bộ lọc ngày của trang Thống kê.
  // `userIds`: lọc cả trang theo nhân viên; bỏ trống thì server chọn người đã
  // bật thông báo.
  show({ since, until, userIds } = {}) {
    return axios.get(this.url, {
      params: {
        since,
        until,
        user_ids: userIds?.length ? userIds : undefined,
      },
    });
  }

  // Admin gỡ một máy: server đặt `retired`, lý do `removed_by_admin`.
  retireDevice(id) {
    return axios.post(`${this.url}/devices/${id}/retire`);
  }
}

export default new PushReportAPI();
